// extracted by mini-css-extract-plugin
export default {"noDataMessage":"NoDataMessage_noDataMessage__0e5XK"};